import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { services } from '../../../mocks/services';

export default function ServicesPreview() {
  const preview = services.slice(0, 4);
  const { t, i18n } = useTranslation();
  const lang = (i18n.language === 'en' ? 'en' : 'es') as 'es' | 'en';

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-brand-green font-semibold text-sm uppercase tracking-wider">{t('sp_eyebrow')}</span>
          <h2 className="font-heading font-bold text-brand-blue-dark text-4xl mt-2 mb-4">{t('sp_heading')}</h2>
          <div className="w-16 h-1 bg-brand-green rounded-full mx-auto" />
          <p className="text-gray-500 max-w-xl mx-auto mt-4 text-sm leading-relaxed">
            {t('sp_sub')}
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {preview.map((service) => (
            <div key={service.id} className="group bg-white rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-300">
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                {service.tag && (
                  <span className="absolute top-3 left-3 z-10 bg-brand-green-dark text-white text-xs font-semibold px-3 py-1 rounded-full">
                    {service.tag[lang]}
                  </span>
                )}
                <img
                  src={service.image}
                  alt={service.title[lang]}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-blue-dark/50 to-transparent" />
              </div>
              {/* Content */}
              <div className="p-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-brand-green-light/50 mb-3">
                  <i className={`${service.icon} text-brand-green-dark text-lg`} />
                </div>
                <h3 className="font-heading font-bold text-brand-blue-dark text-base mb-2">{service.title[lang]}</h3>
                <p className="text-gray-500 text-xs leading-relaxed mb-4">{service.shortDesc[lang]}</p>
                <Link to="/servicios" className="text-brand-green font-semibold text-xs flex items-center gap-1 hover:gap-2 transition-all cursor-pointer">
                  {t('sp_details')} <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/servicios"
            className="inline-flex items-center gap-2 border-2 border-brand-green text-brand-green hover:bg-brand-green hover:text-white font-semibold px-8 py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('sp_all')} <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
